const ehNumero = (valor) => typeof valor === "number" && Number.isFinite(valor);

const ORDEM_DOS_DIAS = [1, 2, 3, 4, 5, 6, 7];

const rotuloDaHora = (hora) => `${String(hora).padStart(2, "0")}:00`;

export const horasComAtencao = (atencao) =>
  (atencao?.branches?.[0]?.groups || []).filter(
    (hora) => (hora.pessoa_minuto || 0) > 0 || (hora.minutos_ocupados || 0) > 0
  );

export const cartoesDoPico = ({ atencao }) => {
  const filial = atencao?.branches?.[0];
  return {
    occupied_time_accum: filial?.pessoa_minuto ?? null,
    peak_people: filial?.pico ?? null,
    occupancy_rate: filial?.ocupacao_pct ?? null,
  };
};

export const indisponiveisDoPico = (cartoes) =>
  ["occupied_time_accum", "peak_people", "occupancy_rate"].filter(
    (chave) => !ehNumero(cartoes?.[chave])
  );

export const tabelasDoPico = (atencao) => {
  const horas = horasComAtencao(atencao);
  const comAtencao = horas.filter((hora) => (hora.pessoa_minuto || 0) > 0);
  const media = comAtencao.length
    ? comAtencao.reduce((soma, hora) => soma + hora.pessoa_minuto, 0) /
      comAtencao.length
    : 0;
  const linhas = horas
    .map((hora) => ({
      hour: rotuloDaHora(hora.hour),
      permanence: hora.pessoa_minuto ?? 0,
      occupation: hora.ocupacao_pct ?? 0,
      peak: hora.pico ?? null,
    }))
    .sort((a, b) => b.permanence - a.permanence);
  const numerar = (lista) =>
    lista.map((linha, indice) => ({ ...linha, key: indice + 1 }));
  return {
    above_mean: numerar(linhas.filter((linha) => linha.permanence >= media)),
    below_mean: numerar(linhas.filter((linha) => linha.permanence < media)),
  };
};

const valorDaMetrica = (grupo, metrica) => {
  if (metrica === "occupancy_rate") return grupo?.ocupacao_pct ?? 0;
  if (metrica === "peak_people") return grupo?.pico ?? 0;
  return grupo?.pessoa_minuto ?? 0;
};

export const graficosDoPico = ({ porHoraEDia, porDia, metrica }) => {
  const celulas = porHoraEDia?.branches?.[0]?.groups || [];
  const dias = porDia?.branches?.[0]?.groups || [];
  if (!celulas.length && !dias.length) return null;
  const nomeDoDia = new Map();
  celulas.forEach((celula) =>
    nomeDoDia.set(celula.weekday, celula.weekday_name)
  );
  dias.forEach((dia) => nomeDoDia.set(dia.weekday, dia.weekday_name));
  const diasAtivos = ORDEM_DOS_DIAS.filter((dia) => nomeDoDia.has(dia));
  const nomes = diasAtivos.map((dia) => nomeDoDia.get(dia));
  const horas = [...new Set(celulas.map((celula) => celula.hour))].sort(
    (a, b) => a - b
  );
  const porChave = new Map(
    celulas.map((celula) => [`${celula.weekday}-${celula.hour}`, celula])
  );
  const porDiaDaSemana = new Map(dias.map((dia) => [dia.weekday, dia]));
  return {
    matrixGraphData: {
      days: nomes,
      data: horas.map((hora) => ({
        name: `${rotuloDaHora(hora)}h`,
        data: diasAtivos.map((dia) => ({
          x: nomeDoDia.get(dia),
          y: Number(
            valorDaMetrica(porChave.get(`${dia}-${hora}`), metrica).toFixed(2)
          ),
        })),
      })),
    },
    barGraphData: {
      days: nomes,
      data: diasAtivos.map((dia) =>
        Number(valorDaMetrica(porDiaDaSemana.get(dia), metrica).toFixed(2))
      ),
    },
  };
};
